module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.employmentIds.length === 1 ? 'Opret engangsydelse' : 'Opret engangsydelser'))]), _vm._v(" "), _c('p', {
    staticClass: "d-modal__subtitle"
  }, [_vm._v(_vm._s(_vm.subtitleText))])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "create-form__grid"
  }, [_c('div', {
    staticClass: "d-input-group cf-loenart"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Lønkode *")]), _vm._v(" "), _c('DSelect', {
    ref: "loenartSelect",
    attrs: {
      "items": _vm.salaryCodesForDSelect,
      "multiple": false,
      "placeholder": 'Vælg lønkode',
      "itemsSelected": _vm.selectedSalaryCodeForDSelect,
      "isShowRemoveButton": false
    },
    on: {
      "add": _vm.onSelectLoenart,
      "remove": function($event) {
        return _vm.onSelectLoenart(null)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group cf-antal"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.beloebAllowed ? 'Antal' : 'Antal *'))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.antal),
      expression: "antal"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "placeholder": "Indtast antal"
    },
    domProps: {
      "value": (_vm.antal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.antal = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group cf-beloeb"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.beloebAllowed ? 'Beløb *' : 'Beløb'))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'top',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        zIndex: 12312312312312,
        onShow: function () { return !_vm.beloebAllowed; }
      }),
      expression: "{\n                  arrow: true,\n                  placement: 'top',\n                  animateFill: false,\n                  animation: 'shift-away',\n                  boundary: 'window',\n                  zIndex: 12312312312312,\n                  onShow: () => !beloebAllowed\n                }"
    }],
    staticClass: "cf-beloeb__field",
    attrs: {
      "content": _vm.beloebAllowed ? '' : 'Kræver løbenummer 0'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beloeb),
      expression: "beloeb"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "disabled": !_vm.beloebAllowed,
      "placeholder": _vm.beloebAllowed ? 'Indtast beløb' : ''
    },
    domProps: {
      "value": (_vm.beloeb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beloeb = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "cf-hint text-explainer"
  }, [_vm._v("\n          " + _vm._s(_vm.beloebHint) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group cf-dato"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Aktivitetsdato *")]), _vm._v(" "), _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.dato,
      "width100": true
    },
    on: {
      "changed": function($event) {
        return _vm.setDato($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group cf-omk"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Afvigende omkostningssted")]), _vm._v(" "), _c('DSelect', {
    attrs: {
      "items": _vm.costCentersForDSelect,
      "multiple": false,
      "placeholder": 'Vælg afvigende omkostningssted (valgfri)',
      "itemsSelected": _vm.selectedCostCenterForDSelect,
      "isShowRemoveButton": true
    },
    on: {
      "add": _vm.onSelectCostCenter,
      "remove": function($event) {
        return _vm.onSelectCostCenter(null)
      }
    }
  })], 1)]), _vm._v(" "), (_vm.validationMessage) ? _c('p', {
    staticClass: "text-explainer text-explainer--danger"
  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__child"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'right',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        zIndex: 12312312312312
      }),
      expression: "{\n                  arrow: true,\n                    placement : 'right',\n                    animateFill: false,\n                    animation : 'shift-away',\n                    boundary: 'window',\n                    zIndex: 12312312312312\n                  }"
    }],
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting,
      'do-bttn--submit--disabled': !_vm.isValid
    },
    attrs: {
      "disabled": !_vm.isValid || _vm.isSubmitting,
      "content": _vm.saveKeyTooltip
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.submitButtonLabel) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c15e7e38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/KMD/CreateEngangsydelse.vue
// module id = 2117
// module chunks = 1